import React from 'react';

/**
 * Dekorativ kartbakgrund till inloggningen.
 *
 * Ritad som inline-SVG i stället för en riktig karta: sidan visas innan
 * användaren är inloggad, och då ska vi varken hämta kartrutor från
 * OpenStreetMap eller dra igång Leaflet. Rutten animeras med
 * stroke-dashoffset, vilket är billigt och stängs av automatiskt för den
 * som bett om mindre rörelse (se App.css).
 */
export default function MapBackdrop() {
  return (
    <div className="auth-backdrop" aria-hidden="true">
      <svg
        className="auth-backdrop__svg"
        viewBox="0 0 1200 800"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Färgerna sätts med klasser, inte med stopColor-attribut:
              CSS-variabler fungerar inte i SVG:ns presentationsattribut. */}
          <linearGradient id="cruze-route" x1="0" y1="1" x2="1" y2="0">
            <stop className="stop-accent" offset="0%" />
            <stop className="stop-warm" offset="55%" />
            <stop className="stop-cool" offset="100%" />
          </linearGradient>

          <radialGradient id="cruze-glow" cx="50%" cy="50%" r="50%">
            <stop className="stop-accent stop-glow-in" offset="0%" />
            <stop className="stop-accent stop-glow-out" offset="100%" />
          </radialGradient>

          <radialGradient id="cruze-glow-cool" cx="50%" cy="50%" r="50%">
            <stop className="stop-cool stop-glow-cool-in" offset="0%" />
            <stop className="stop-cool stop-glow-out" offset="100%" />
          </radialGradient>
        </defs>

        {/* Ljussken som ger djup bakom kartan */}
        <circle cx="180" cy="700" r="360" fill="url(#cruze-glow)" />
        <circle cx="1010" cy="130" r="340" fill="url(#cruze-glow-cool)" />

        {/* Kvarter */}
        <g className="backdrop-blocks">
          <rect x="200" y="170" width="150" height="80" rx="8" />
          <rect x="450" y="170" width="150" height="80" rx="8" />
          <rect x="700" y="350" width="150" height="80" rx="8" />
          <rect x="200" y="530" width="150" height="80" rx="8" />
          <rect x="950" y="530" width="140" height="80" rx="8" />
          <rect x="450" y="350" width="150" height="80" rx="8" />
        </g>

        {/* Gatunät */}
        <g className="backdrop-roads">
          <path d="M -50 120 H 1250" />
          <path d="M -50 300 H 1250" />
          <path d="M -50 480 H 1250" />
          <path d="M -50 660 H 1250" />
          <path d="M 150 -50 V 850" />
          <path d="M 400 -50 V 850" />
          <path d="M 650 -50 V 850" />
          <path d="M 900 -50 V 850" />
          <path d="M 1100 -50 V 850" />
          <path d="M -50 850 L 400 300" />
          <path d="M 650 850 L 1250 200" />
        </g>

        {/* Rutten genom staden */}
        <path
          className="backdrop-route"
          d="M 150 720 L 150 480 L 400 480 L 400 300 L 650 300 L 650 120 L 900 120"
          fill="none"
          stroke="url(#cruze-route)"
        />
        <path
          className="backdrop-route-dash"
          d="M 150 720 L 150 480 L 400 480 L 400 300 L 650 300 L 650 120 L 900 120"
          fill="none"
        />

        {/* Start och mål */}
        <circle className="backdrop-pulse" cx="150" cy="720" r="14" />
        <circle className="backdrop-start" cx="150" cy="720" r="7" />
        <g className="backdrop-destination" transform="translate(900 120)">
          <path d="M 0 6 C -12 -8 -18 -14 -18 -22 A 18 18 0 0 1 18 -22 C 18 -14 12 -8 0 6 Z" />
          <circle cx="0" cy="-22" r="6.5" />
        </g>
      </svg>
    </div>
  );
}
